import { useFormikContext } from 'formik';
import * as React from 'react';

export type FormikAutoSubmitProps = {
  delay: number;
};

const FormikAutoSubmit = ({ delay }: FormikAutoSubmitProps) => {
  const formik = useFormikContext();

  React.useEffect(() => {
    const tl = window.setTimeout(formik.submitForm, delay);
    return () => window.clearTimeout(tl);
  }, [delay, formik.values]);

  return null;
};

export default FormikAutoSubmit;
